import { Link } from "react-router-dom";

export function BreakingTag({ label = "EILMELDUNG", className = "" }) {
  return (
    <span data-testid="breaking-tag" className={`inline-flex items-center gap-1.5 bg-breaking text-white text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 ${className}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-white" />
      {label}
    </span>
  );
}

export function Kicker({ children, breaking }) {
  if (breaking) return <BreakingTag />;
  return (
    <span className="font-body uppercase text-[11px] font-bold tracking-[0.12em] text-gold">
      {children}
    </span>
  );
}
